import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.setupForm()
  }

  setupForm() {
    const form = this.element
    const textarea = form.querySelector('textarea')
    
    if (textarea) {
      // Auto-resize textarea
      textarea.addEventListener('input', () => {
        textarea.style.height = 'auto'
        textarea.style.height = Math.min(textarea.scrollHeight, 100) + 'px'
      })
      
      // Submit on Enter (but allow Shift+Enter for new lines)
      textarea.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault()
          form.requestSubmit() // Esto mantiene el comportamiento de Turbo
        }
      })
      
      // Focus textarea
      textarea.focus()
    }
  }

  handleSubmit(event) {
    const textarea = this.element.querySelector('textarea')
    if (textarea) {
      textarea.value = ''
      textarea.style.height = 'auto'
    }
  }
}
